export const BLOKKENDOOS_SELECTORS = {
  CANDIDATE_MODAL: '#candidateLogin',
  CANDIDATE_MODAL_FLASH_MESSAGE: '#candidateLogin .js-flash-message',
  EMAIL_NOT_UNIQUE_CONTENT: 'not_unique_email'
};

export const META_TAGS = {
  BANNER_IMAGE: 'banner_image',
  SIGNUP_FOR: 'signup_for',
  SITE_ABBR: 'site_abbr',
  SIGNUP_EVENT_LABEL: 'signup_event_label'
};

export const SIGNUP_FOR_MAPPING = {
  university: 'university',
  candidate: 'candidate',
  cvbuilder: 'cvbuilder',
  apply: 'apply',
  applyLong: 'applyLong',
  summerjob: 'summerjob',

  // indeed flow
  candidateIndeed: 'candidateIndeed',
  universityIndeed: 'universityIndeed',
  cvbuilderIndeed: 'cvbuilderIndeed',
  applyIndeed: 'applyIndeed',
  summerjobIndeed: 'summerjobIndeed'
};

export const DEFAULT_I18N_NS = {
  university: 'university',
  candidate: 'candidate',
  cvbuilder: 'cvbuilder',
  apply: 'apply',
  applyLong: 'apply',
  summerjob: 'candidate',

  // indeed flow
  candidateIndeed: 'candidate',
  universityIndeed: 'university',
  applyIndeed: 'apply',
  cvbuilderIndeed: 'cvbuilder',
  summerjobIndeed: 'candidate'
};

export const DEFAULT_BANNER_IMAGE =
  'https://d36bmc1enj16yj.cloudfront.net/production/assets/campaign-images-2018/' +
  '2-d0d482b421bf62ab4df0e12d942ecfa3506fcc9397d4ac7fcd73d1e4726e5cb0.jpg';

export const DEFAULT_SIGNUP_FOR = 'university';

export const DEFAULT_SITE_ABBR = 'YC';

export const GTM_CONFIGS = {
  event: 'Aanmelding compleet',
  eventCategory: 'Aanmelding compleet',
  eventAction: 'Verkorte aanmelding'
};

export const ENDPOINTS = {
  partial_candidates: 'partial_candidates',
  candidates: 'candidates',
  resource: 'resource',
  unique_email_check: 'unique_email_check',
  settings_data: 'settings_data',
  educations: 'educations',
  file_uploads: 'file_uploads'
};
